import {
  createBaseAsyncReducer,
  createFailAction,
  createStartAction,
  createSuccessAction,
  initialState,
} from 'app/api/redux-util/async-helpers';
import { LIST_ASSETS_MULTI } from 'app/api/redux-bridge/bridge-methods';
import { combineReducers } from 'redux';
import {
  getParams,
  POSSIBLE_SWIMLANES,
} from 'app/api/redux-bridge/assetGroups/recommendations/utils';
import arrayFindIndex from 'array-find-index';
import deepEqual from 'deep-equal';

function transformer(data) {
  if (data && data.content) {
    return {
      ...data,
      content: data.content.map(c => c.vbid),
    };
  }
  return { ...data, content: [] };
}

const baseReducer = createBaseAsyncReducer(LIST_ASSETS_MULTI, transformer);

/**
 * Make each list loom like a separate async node
 */
function createReducer(id) {
  /**
   * Figure out which list index goes with this id by comparing to the
   * submitted params
   */
  function getIndex(lists) {
    return arrayFindIndex(lists, el => deepEqual(getParams(id), el));
  }

  return function(state = initialState, action) {
    if (action.type === createStartAction(LIST_ASSETS_MULTI).type) {
      const allParams = action.data[0].lists;
      const index = getIndex(allParams);
      if (index !== -1) {
        return baseReducer(state, {
          type: action.type,
          // The params for just this list
          data: allParams[index],
        });
      }
    } else if (action.type === createSuccessAction(LIST_ASSETS_MULTI).type) {
      const arg = action.args[0];
      const index = getIndex(arg.lists);
      if (index !== -1) {
        return baseReducer(state, {
          type: action.type,
          // Data and params for just this list
          data: { ...action.data.lists[index] },
          args: [arg.lists[index]],
        });
      }
    } else if (action.type === createFailAction(LIST_ASSETS_MULTI).type) {
      const index = getIndex(action.args[0].lists);
      if (index !== -1) {
        // Failures do not require any data differentiation
        return baseReducer(state, action);
      }
    }
    return state;
  };
}

const reducers = POSSIBLE_SWIMLANES.reduce((acc, cv) => {
  acc[cv] = createReducer(cv);
  return acc;
}, {});

export default combineReducers(reducers);
